import { Injectable } from "@angular/core";
import { ApiAction } from "../../api-actions";
import { genericApiAction } from "../../onsip-api-action-new";
import {
  OAuth2SignupAccount,
  OAuth2SignupAccountApi,
  OAuth2SignupAccountParams,
  oAuth2SignupAccountApiConverter as clean
} from "./oauth-2-signup-account";

@Injectable({ providedIn: "root" })
export class OAuth2SignupAccountService {
  async oAuth2SignupAccount(params: OAuth2SignupAccountParams): Promise<OAuth2SignupAccount> {
    const response = await genericApiAction({
      Action: ApiAction.OAuth2SignupAccount,
      ...params
    });
    const raw = (response as any).Result[ApiAction.OAuth2SignupAccount] as OAuth2SignupAccountApi;
    return clean(raw);
  }
}
